<template>
  <div class="header">
    <div class="logo">
      <div class="logoImg">
        <div
          :style="{
            'background-image': `url(${require('@/assets/images/MicrosoftTeams-image_homes.png')})`,
          }"
          class="homes"
        ></div>
        <!-- <div
          :style="{
            'background-image': `url(${require('@/assets/images/Atkinslogo.png')})`,
          }"
          class="atkins"
        ></div> -->
      </div>
    </div>
    <div class="navs">
      <div class="nav">
        <a href="#about">the site</a>
      </div>
      <div class="nav">
        <a href="#plans">the plans</a>
      </div>
      <div class="nav">
        <a href="#involve">get involved</a>
      </div>
      <div class="nav">
        <a href="#register">stay informed</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>